module.exports = __webpack_public_path__ + "img/advantage-2.cbe5884c.png";